module.exports = __webpack_public_path__ + "images/5f8b704e16e38dc0b6ce59884a2eddeb.svg";